import styled from 'styled-components'

export const CreateBeneficiaryFormStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  height: 100%;
  display: flex;
  flex-direction: column;
`
